import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const ProfessionalImage = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 100px;
  margin-bottom: 10px;
`

export const PlanButton = styled.button`
  width: 100%;
  height: 56px;
  border-radius: 40px;
  box-shadow: 0px 1px 3px #0000004D;
  border: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 10px 13px 20px;
  transition: all 0.3s;

  &:hover {
    background: #F5F5F5;
    box-shadow: 0px 1px 3px #0000004D;
  }
 
 &:disabled {
  background: #F5F5F5;
  box-shadow: none;
  color: #898989 !important;
  cursor: not-allowed;
 }
`

export const PlanInfo = styled.div`

`

export const PlanButtonIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const PlansButtonWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  gap: 10px;
  flex-direction: column;
`